import { forwardRef, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Colors } from "../../../config";
import { Wrapper } from "../../../config/StyledComponents";
import InputLabel from "../../InputLabel";
import "./datepicker.css";
import DatePickerField from "./DatePickerField";
import styled from "styled-components";

const InputDatePicker = ({
  label,
  required,
  labelFontColor = Colors.coolGrey,
  labelFontSize = "1.125rem",
  labelFontWeight = 400,
  value,
  onChange,
  disabled,
  maxDate,
  minDate,
  width,
  format,
  placeholder,
  helperText,
  name,
  borderRadius,
  scrollableYearDropdown,
  scrollableMonthDropdown,
  dropdownMode,
  placeHolderColor,
}) => {
  const inputRef = useRef(null);
  const CustomInput = forwardRef((props, ref) => {
    return <DatePickerField {...props} ref={ref} />;
  });
  return (
    <Wrapper>
      <Label>
        {label} {required && <Required>*</Required>}
      </Label>
      <DatePicker
        selected={value}
        onChange={(date) => {
          onChange(date);
        }}
        customInput={
          <CustomInput
            placeholderText={placeholder}
            width={width}
            inputRef={inputRef}
            helperText={helperText}
            label={label}
            name={name}
            borderRadius={borderRadius}
            placeHolderColor={placeHolderColor}
          />
        }
        dateFormat={format || "dd MMM yyyy"}
        maxDate={maxDate}
        minDate={minDate}
        disabled={disabled}
        showYearDropdown={true}
        showMonthDropdown={true}
        dropdownMode={dropdownMode}
      />
    </Wrapper>
  );
};

const Label = styled.div`
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
`;

const Required = styled.span`
  color: red;
`;

export default InputDatePicker;
